import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Linkedin } from "lucide-react";
import footerLogoAsset from "@/assets/circlo-logo-white.png";

const footerLogo = footerLogoAsset;

const Footer = () => {
  const { i18n } = useTranslation();

  const langPrefix = i18n.language === 'de' ? '/de' : i18n.language === 'nl' ? '/nl' : '';
  const homeLink = langPrefix || '/';

  return (
    <footer className="footer-dark border-t border-border">
      <div className="container mx-auto px-4 py-10 md:py-14">
        {/* Four-column link grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <Link to={homeLink} className="block mb-4" aria-label="Circlo home">
              <img src={footerLogo} alt="Circlo" className="h-10 w-auto" width={682} height={256} loading="lazy" />
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs">
              Company apparel. Worth wearing.
            </p>
            <p className="text-xs text-muted-foreground mt-3">Amsterdam · Operating across Portugal, Italy, Turkey</p>
            <a
              href="https://www.linkedin.com/company/wearecirclo/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-muted-foreground hover:text-fuego transition-smooth"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5" />
            </a>
          </div>

          <div>
            <h3 className="font-semibold text-primary-foreground mb-3 text-sm">Explore</h3>
            <ul className="space-y-2">
              <li><Link to={`${langPrefix}/work`} className="text-sm text-muted-foreground hover:text-primary transition-smooth">Work</Link></li>
              <li><Link to={`${langPrefix}/how-we-work`} className="text-sm text-muted-foreground hover:text-primary transition-smooth">How we work</Link></li>
              <li><Link to={`${langPrefix}/about`} className="text-sm text-muted-foreground hover:text-primary transition-smooth">About</Link></li>
              <li><Link to={`${langPrefix}/contact`} className="text-sm text-muted-foreground hover:text-primary transition-smooth">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-primary-foreground mb-3 text-sm">Legal</h3>
            <ul className="space-y-2">
              <li><Link to={`${langPrefix}/privacy`} className="text-sm text-muted-foreground hover:text-primary transition-smooth">Privacy</Link></li>
              <li><Link to={`${langPrefix}/terms`} className="text-sm text-muted-foreground hover:text-primary transition-smooth">Terms</Link></li>
              <li><span className="text-sm text-muted-foreground">DPA available on request</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-6 pt-5 border-t hairline">
          <p className="text-xs text-muted-foreground text-center">
            Naviza B.V. · Eerste Passeerdersdwarsstraat 82-86, Amsterdam · BTW NL863405029B01 · © 2025–2026 Circlo
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
